import { useGetPerson } from '@/features/api/hooks/participant/useGetPerson';
import { useGetGeoArea } from '@/features/api/hooks/participant-geo-area/useGetGeoArea';

/**
 * Resolves the current user's home geo area (via their `homeAreaId`).
 * Both underlying queries are cached/deduped by React Query, so components can
 * call this independently instead of threading the area through props.
 */
export const useHomeGeoArea = () => {
  const { data: person } = useGetPerson();
  return useGetGeoArea(person?.homeAreaId);
};
